// isNaN polyfill
Number.isNaN = Number.isNaN || function (value) {
    return typeof value === 'number' && isNaN(value);
};

function isInt(n) {
    return typeof n === 'number' && !isNaN(n);
}

YP.TypeTicketManager = function() {
    var formTypeTicket = $('form.type-ticket');
    return {
        init: function() {
            if (formTypeTicket && formTypeTicket.length !== 0) {
                YP.TypeTicketManager().initTypeTicketForm();
                if (formTypeTicket[0].dataset.edit) {
                    YP.TypeTicketManager().initTypeTicketEditForm();
                }
            }
        },
        initTypeTicketEditForm: function() {
            var el = $('#typeTicket_amount'),
                amount = parseFloat(el.val().replace(',', '.')),
                comUrl = $calcCommissionDiv.data('com-url'),
                nameHost = $calcCommissionDiv.data('namehost'),
                realAmountInput = $('.real_amount input');

            $calcCommissionDiv = $('.js-calc-commission');
            $calcCommissionDiv.hide();
            $('.js-commission_searching').show();

            var typeTicketUnlockableDisable = $('.unlockable_type_ticket_disable');
            if (typeTicketUnlockableDisable.length >= 1) {
                $('#typeTicket_check_unlocked_after').attr('checked', false);
            }

            $.ajax({
                type: 'GET',
                url: comUrl,
                data: ({
                    amount: Number.isNaN(amount) ? 0 : amount,
                }),
                dataType: "json",
                success: function(data) {
                    $('.js-commission_searching').hide();
                    $calcCommissionDiv.show();
                    costCb = parseFloat(data.commission);
                    costHost = parseFloat(data.host_commission);
                    costPp = parseFloat(data.paypal_commission);

                    restCb = (amount - costCb).toFixed(2);
                    restPaypal = (amount - costPp).toFixed(2);
                    if (costHost > 0) {
                        costHostHtml = ' <strong>' + costHost + '€</strong> de commission ' + nameHost + ',';
                        restCb = (restCb - costHost).toFixed(2);
                        restPaypal = (restPaypal - costHost).toFixed(2);
                    } else {
                        costHostHtml = "";
                    }

                    html = 'Carte bancaire : <strong>' + costCb + '€</strong> de commission Yurplan,' + costHostHtml + ' il vous reste : <strong>' + restCb + '€</strong>.';
                    if ($calcCommissionDiv.data('paypal') == 1) {
                        html += '<br />';
                        html += 'PayPal: <strong>' + costPp + '€</strong> de commission Yurplan,' + costHostHtml + ' il vous reste : <strong>' + restPaypal + '€</strong>.';
                    }
                    realAmountInput.val(restCb);
                    $calcCommissionDiv.html(html);
                }
            });
        },
        initTypeTicketForm: function() {
            $('form.type-ticket .pack_tickets .pack-option input[type=text]').each(function() {
                if ($(this).val() !== "") {
                    $(this).parents('.pack-option').find('input[type=checkbox]').attr('checked', 'checked');
                    $(this).parents('.pack-option span').show();
                }
            });

            $calcCommissionDiv = $('.js-calc-commission');

            $('#typeTicket_amount').donetyping(function() {
                var el = $(this),
                    amount = parseFloat(el.val().replace(',', '.')),
                    comUrl = $calcCommissionDiv.data('com-url'),
                    nameHost = $calcCommissionDiv.data('namehost'),
                    realAmountInput = $('.real_amount input');

                if (amount) {
                    if (amount == 0) {
                        $calcCommissionDiv.html('');
                        realAmountInput.val('');
                    } else {
                        $calcCommissionDiv.hide();
                        $('.js-commission_searching').show();
                        $.ajax({
                            type: 'GET',
                            url: comUrl,
                            data: ({
                                amount: Number.isNaN(amount) ? 0 : amount,
                            }),
                            dataType: "json",
                            success: function(data) {
                                $('.js-commission_searching').hide();
                                $calcCommissionDiv.show();
                                costCb = parseFloat(data.commission);
                                costHost = parseFloat(data.host_commission);
                                costPp = parseFloat(data.paypal_commission);

                                restCb = (amount - costCb).toFixed(2);
                                restPaypal = (amount - costPp).toFixed(2);
                                if (costHost > 0) {
                                    costHostHtml = ' <strong>' + costHost + '€</strong> de commission ' + nameHost + ',';
                                    restCb = (restCb - costHost).toFixed(2);
                                    restPaypal = (restPaypal - costHost).toFixed(2);
                                } else {
                                    costHostHtml = "";
                                }

                                html = 'Carte bancaire: <strong>' + costCb + '€</strong> de commission Yurplan,' + costHostHtml + ' il vous reste : <strong>' + restCb + '€</strong>.';
                                if ($calcCommissionDiv.data('paypal') == 1) {
                                    html += '<br />';
                                    html += 'PayPal: <strong>' + costPp + '€</strong> de commission Yurplan,' + costHostHtml + ' il vous reste : <strong>' + restPaypal + '€</strong>.';
                                }
                                realAmountInput.val(restCb);
                                $calcCommissionDiv.html(html);
                            }
                        });
                    }
                } else {
                    $calcCommissionDiv.html('');
                }
            }, 1000);

            $('#typeTicket_real_amount').donetyping(function() {
                var el = $(this),
                    amount = el.val().replace(',', '.'),
                    comUrl = $calcCommissionDiv.data('com-url'),
                    nameHost = $calcCommissionDiv.data('namehost'),
                    realAmountInput = $('.amount input');

                    $calcCommissionDiv.hide();
                    $('.js-commission_searching').show();
                if (isInt(parseFloat(amount))) {
                    $.ajax({
                        type: 'GET',
                        url: comUrl,
                        data: ({
                            amount: Number.isNaN(amount) ? 0 : amount,
                            reverse: 1,
                        }),
                        dataType: "json",
                        success: function(data) {
                            $('.js-commission_searching').hide();
                            $calcCommissionDiv.show();
                            amount = parseFloat(amount);
                            costCb = parseFloat(data.commission);
                            costHost = parseFloat(data.host_commission);
                            costPp = parseFloat(data.paypal_commission);

                            realAmount = (amount + costCb + costHost).toFixed(2);
                            restCb = (realAmount - costCb).toFixed(2);
                            restPaypal = (realAmount - costPp).toFixed(2);

                            if (costHost > 0) {
                                costHostHtml = ' <strong>' + costHost + '€</strong> de commission ' + nameHost + ',';
                                restCb = (restCb - costHost).toFixed(2);
                                restPaypal = (restPaypal - costHost).toFixed(2);
                            } else {
                                costHostHtml = "";
                            }

                            html = 'Carte bancaire: <strong>' + costCb + '€</strong> de commission Yurplan,' + costHostHtml + ' il vous reste : <strong>' + restCb + '€</strong>.';
                            if ($calcCommissionDiv.data('paypal') == 1) {
                                html += '<br />';
                                html += 'PayPal: <strong>' + costPp + '€</strong> de commission Yurplan,' + costHostHtml + ' il vous reste : <strong>' + restPaypal + '€</strong>.';
                            }
                            realAmountInput.val(realAmount);
                            $calcCommissionDiv.html(html);
                        }
                    });
                } else {
                    $calcCommissionDiv.html('');
                }
            }, 1000);

            $('form.type-ticket input[name="typeTicket[is_free]"]').on('click', function() {
                $('form.type-ticket .amount input').val(null);
                $('form.type-ticket .real_amount input').val(null);
                $('form.type-ticket .vat_rate select').val( $('form.type-ticket .vat_rate').attr('data-default'));
                if ($(this).val() == 1) {
                    $('form.type-ticket .amount input').attr('disabled', true);
                    $('form.type-ticket .amount').addClass('c-form__line_disabled');
                    $('form.type-ticket .real_amount input').attr('disabled', true);
                    $('form.type-ticket .real_amount').addClass('c-form__line_disabled');
                    $('form.type-ticket .vat_rate select').attr('disabled', true);
                    $('form.type-ticket .vat_rate').addClass('c-form__line_disabled');
                    $('.amount_form').hide();

                    $calcCommissionDiv.html('');
                } else {
                    $('form.type-ticket .amount input').attr('disabled', false);
                    $('form.type-ticket .amount').removeClass('c-form__line_disabled');
                    $('form.type-ticket .real_amount input').attr('disabled', false);
                    $('form.type-ticket .real_amount').removeClass('c-form__line_disabled');
                    $('form.type-ticket .vat_rate select').attr('disabled', false);
                    $('form.type-ticket .vat_rate').removeClass('c-form__line_disabled');
                    $('.amount_form').show();

                }
            });
            $('form.type-ticket input[name="typeTicket[is_free]"]').removeAttr('disabled');

            $('form.type-ticket .pack_tickets .pack-option input[type=text]').each(function() {
                if ($(this).val() !== "") {
                    $(this).parents('.pack-option').find('input[type=checkbox]').attr('checked', 'checked');
                    $(this).parents('.pack-option span').show();
                }
            });

            $('form.type-ticket .pack_tickets input[type=checkbox]').live('click', function() {
                $('form.type-ticket .pack_tickets .input-' + $(this).attr('data-type')).toggle();
                if ($('form.type-ticket .pack_tickets .input-' + $(this).attr('data-type')).is(':visible')) {
                    $('form.type-ticket .pack_tickets .input-' + $(this).attr('data-type') + ' input').val(1);
                } else {
                    $('form.type-ticket .pack_tickets .input-' + $(this).attr('data-type') + ' input').val(0);
                }
            });
            // TTC/HT compute
            function updatePriceWithoutVat() {
                const rawVatRate = $('.js-vat-select').val();
                if (rawVatRate == null) {
                    $('.js-calc-ht').hide();
                    return;
                }
                const vatRate = Number.parseFloat(rawVatRate);
                const priceWithVat = Number.parseFloat($('.js-amount').val());
                if (Number.isNaN(priceWithVat) || Number.isNaN(vatRate)) {
                    $('#intraVatNumber').hide();
                    return;
                }
                if (vatRate !== 0) {
                    $('#intraVatNumber').show();
                } else {
                    $('#intraVatNumber').hide();
                }
                const priceWithoutVat = (priceWithVat / (1 + vatRate / 100)).toFixed(2);
                $('.js-calc-ht').html("Prix HT : " + priceWithoutVat + '€');
                $('.js-calc-ht').show();
            }
            $('.js-vat-select').on('change', updatePriceWithoutVat);
            $('.js-amount').on('change', updatePriceWithoutVat);
            updatePriceWithoutVat();
        },
    };
};

window.addEventListener("load", function() {
    YP.TypeTicketManager().init();
});
